import {createContext, useContext, useEffect, useState} from "react";
import CurrencyExchangerService from "../services/CurrencyExchangerService";

// Create Context
const ExchangeContext = createContext();

const initialReserveAmount = parseFloat(process.env.REACT_APP_RESERVE) || 540144.0;
const initialMinAmount = parseFloat(process.env.REACT_APP_MIN_AMOUNT) || 100;
const initialReserveCurrency = process.env.REACT_APP_RESERVE_CURRENCY || "EUR";
const initialMinAmountCurrency = process.env.REACT_APP_MIN_AMOUNT_CURRENCY || "USDT";

export const ExchangeProvider = ({ children }) => {
    const [fromValue, setFromValue] = useState("10000");
    const [fromCurrency, setFromCurrency] = useState("USDT");
    const [toValue, setToValue] = useState("");
    const [toCurrency, setToCurrency] = useState("EUR");
    const [exchangeRate, setExchangeRate] = useState();
    const [selectedCountry, setSelectedCountry] = useState("");

    const [minAmount, setMinAmount] = useState(initialMinAmount);
    const [reserve, setReserve] = useState(initialReserveAmount);

    // Set initial toValue when exchangeRate is available
    useEffect(() => {
        if (exchangeRate && fromValue && !toValue) {
            const numericFromValue = parseFloat(fromValue) || 0;
            const calculatedValue = numericFromValue * exchangeRate;
            setToValue(calculatedValue);
        }
    }, [exchangeRate, fromValue, toValue]);

    useEffect(() => {
        const convertMinAmount = async () => {
            try {
                if (fromCurrency === initialMinAmountCurrency) {
                    setMinAmount(initialMinAmount);
                    return;
                }

                const data = await CurrencyExchangerService.fetchCurrencyData(initialMinAmountCurrency.toLowerCase());
                if (data && data[fromCurrency.toLowerCase()]) {
                    const rate = data[fromCurrency.toLowerCase()];
                    setMinAmount(initialMinAmount * rate);
                }
            } catch (error) {
                console.error("Error converting min amount:", error);
                setMinAmount(initialMinAmount);
            }
        };

        convertMinAmount();
    }, [fromCurrency]);

    useEffect(() => {
        const convertReserve = async () => {
            try {
                if (toCurrency === initialReserveCurrency) {
                    setReserve(initialReserveAmount);
                    return;
                }

                const data = await CurrencyExchangerService.fetchCurrencyData(initialReserveCurrency.toLowerCase());
                if (data && data[toCurrency.toLowerCase()]) {
                    const rate = data[toCurrency.toLowerCase()];
                    setReserve(initialReserveAmount * rate);
                }
            } catch (error) {
                console.error("Error converting reserve:", error);
                setReserve(initialReserveAmount);
            }
        };

        convertReserve();
    }, [toCurrency]);

    return (
        <ExchangeContext.Provider value={{
            fromValue,
            setFromValue, // No formatting here
            fromCurrency,
            setFromCurrency,
            toValue,
            setToValue, // No formatting here
            toCurrency,
            setToCurrency,
            exchangeRate,
            setExchangeRate,
            selectedCountry,
            setSelectedCountry,
            reserve,
            minAmount
        }}>
            {children}
        </ExchangeContext.Provider>
    );
};

// Custom Hook for easy access
export const useExchange = () => {
    return useContext(ExchangeContext);
};